import { ActionButton, SimpleText, ToggleGroup, YStack } from '@my/ui'
import { color } from '@my/util'

export const ToggleButtonGroup = ({
  active,
  onChange,
  options = ['3 Months', '6 Months', '1 Year'],
  isSmall = false,
}) => {
  return (
    <YStack justifyContent={'center'} alignItems={'flex-start'}>
      <YStack flexDirection="row" borderWidth={1} borderColor={color.dullGrey} borderRadius="$10">
        {options.map((option) => (
          <ActionButton
            unstyled
            alignItems={'center'}
            justifyContent={'center'}
            width={85}
            $platform-native={{
              width: isSmall ? 60 : 85,
            }}
            height={30}
            key={option}
            onPress={() => onChange(option)}
            theme={active === option ? 'active' : 'light'}
            backgroundColor={active === option ? color.tzaGreen : color.white}
            borderRadius="$10"
          >
            <SimpleText
              fontSize={12}
              fontWeight={'700'}
              $platform-native={{ fontSize: isSmall ? 9 : 12 }}
              color={active === option ? color.white : color.darkNavy}
            >
              {option}
            </SimpleText>
          </ActionButton>
        ))}
      </YStack>
    </YStack>
  )
}

export const ToggleButton: React.FC<{
  value: string
  currentValue: string
  onClick: () => void
}> = ({ value, currentValue, onClick }) => {
  const isSelected = value === currentValue
  const bgColor = isSelected ? color.tzaGreen : color.white
  const textColor = isSelected ? color.white : color.tzaGreen

  const style = isSelected
  ? {
    backgroundColor: color.tzaGreen,
    color: 'white'
  }
  : {
    backgroundColor: 'white',
    color: color.tzaGreen
  };
  const hoverStyle = {
    cursor: 'pointer', 
    backgroundColor: isSelected ? 'white' : 'rgb(225, 225, 225)',
    color: 'black',
    //fontSize: 16
  }
  return (
    <ToggleGroup.Item
      unstyled
      height={40}
      justifyContent={'center'}
      alignItems={'center'}
      borderWidth={1}
      borderColor={color.tzaGreen}
      width={100}
      $platform-web={{ borderRadius: 6 }}
      $platform-native={{ borderRadius: 6 }}
      value={value}
      //bg={bgColor}
      onPress={onClick}
      style={style}
      hoverStyle={hoverStyle}
    >
      <SimpleText 
        color={textColor} 
        hoverStyle={hoverStyle}
        //fontSize={16} fontWeight={'500'}
      >
        {value}
      </SimpleText>
    </ToggleGroup.Item>
  )
}
